import React from 'react';
import { motion } from "framer-motion";

import Adithya from '../bank/ADITYA-BIRLA-CAPITAL-e1660310165487.jpg';
import Axis from '../bank/axias.png';
import Avanse from '../bank/Avanse.png';
import dcb from '../bank/dcb.png';
import file from '../bank/file.png';
import idfc from '../bank/IDFC-FIRST.png';
import india from '../bank/INDIA-INFOLINE.png';
import indiabull from '../bank/INDIABULLS.png';
import lichousing from '../bank/lichousing3735.png';
import laonwired from '../bank/loanwired3705.png';
import mahindra from '../bank/mahindrafinance3737.png';
import pirmala from '../bank/PIRAMAL-HOUSING-FINANCE.png';
import tata from '../bank/TATA-CAPITAL.png';
import tatahousing from '../bank/TATA-HOUSING.png';
import tvscerdit from '../bank/tvscredit3716.png';
import yesbank from '../bank/YES-BANK.png';

function BankSection() {
  const bankData = [
    Adithya, Axis, Avanse, dcb, file, idfc, india, 
    indiabull, lichousing, laonwired, mahindra, 
    pirmala, tata, tatahousing, tvscerdit, yesbank
  ];

  const containerVariants = {
    animate: {
      x: [0, -1920],
      transition: {
        x: {
          repeat: Infinity,
          repeatType: "loop",
          duration: 30,
          ease: "linear",
        },
      },
    },
  };

  return (
      <div className="w-full py-8 overflow-hidden bg-white mb-10">
        <h2 className="text-3xl font-bold text-center text-[#FF6F00] mb-10">
        Our Banking Partners </h2>
      <motion.div
        className="flex gap-8"
        variants={containerVariants}
        animate="animate"
      >
        {/* First set of logos */}
        <div className="flex gap-8 shrink-0">
          {bankData.map((bank, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.1 }}
              className="w-[200px] h-20 flex items-center justify-center"
            >
              <img
                src={bank}
                alt={`Bank ${index + 1}`}
                className="max-h-16 object-contain"
              />
            </motion.div>
          ))}
        </div>

        {/* Duplicate set for seamless loop */}
        <div className="flex gap-8 shrink-0">
          {bankData.map((bank, index) => (
            <motion.div
              key={`duplicate-${index}`}
              whileHover={{ scale: 1.1 }}
              className="w-[200px] h-20 flex items-center justify-center"
            >
              <img
                src={bank}
                alt={`Bank ${index + 1}`}
                className="max-h-16 object-contain"
              />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
export default BankSection;